import { useHistory } from "react-router-dom";
import * as Routes from "routes";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { StepComponentProps } from "../step-config-file/types";

export const WelcomeCard = (props: StepComponentProps) => {
  const history = useHistory();
  return (
    <Card className="fixed bottom-[30%] left-[40%] flex w-md max-w-full flex-col self-end">
      <CardHeader>
        <CardTitle className="text-lg font-medium">
          {props.data.title}
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-3 text-sm">
        <p>{props.data.description?.paragraph_one}</p>
        <p>{props.data.description?.paragraph_two}</p>
      </CardContent>
      <CardFooter className="justify-end gap-2">
        <Button
          variant="ghost"
          size="sm"
          onClick={() => {
            history.push(Routes.demosPage);
          }}
        >
          Exit
        </Button>
        <Button
          size="sm"
          onClick={() => {
            props.moveToNextLocation({
              ...props.nextCoordinates,
              geocoder_attributes: {},
              zoomLevel: props.zoomLevel,
            });
            props.nextStep();
          }}
        >
          Explore
        </Button>
      </CardFooter>
    </Card>
  );
};
